import React from "react";
import {
  Instagram,
  Facebook,
  Youtube,
  Music2,
  MessageCircle,
  ArrowUpRight,
} from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/**
 * ⚠️ ATUALIZE AQUI: troque os links/handles abaixo pelos perfis reais.
 * O link do WhatsApp deve usar o mesmo número já usado no <WhatsAppFloat />.
 */
const SOCIAL_PROFILES = [
  {
    name: "Instagram Costa Rica",
    handle: "@paragliding_costa_rica",
    href: "https://www.instagram.com/paragliding_costa_rica/",
    icon: Instagram,
    accent: "from-[#E8622D] to-[#F2A65A]",
    description:
      "Photos and videos of the day's flights, straight from Rivas and Dominical.",
  },
  {
    name: "YouTube Costa Rica",
    handle: "Paraglide Costa Rica",
    href: "https://youtube.com/@paraglidecostarica",
    icon: Youtube,
    accent: "from-[#C1392B] to-[#E8622D]",
    description: "Full first-person view (POV) flight videos.",
  },
  {
    name: "TikTok Costa Rica",
    handle: "@tandemparaglidecr",
    href: "https://www.tiktok.com/@tandemparaglidecr",
    icon: Music2,
    accent: "from-[#1F3D2B] to-[#3E8FB0]",
    description: "New releases, customer reviews, and live streams.",
  },
  {
    name: "WhatsApp",
    handle: "Contact us - Costa Rica ",
    href: "https://wa.me/50683455135",
    icon: MessageCircle,
    accent: "from-[#2E8B57] to-[#3E8FB0]",
    description: "Get your questions answered and book your Costa Rica flight directly via WhatsApp.",
  },
  {
    name: "WhatsApp",
    handle: "Contact us - Peru ",
    href: "https://wa.me/51949373734",
    icon: MessageCircle,
    accent: "from-[#2E8B57] to-[#3E8FB0]",
    description: "Get your questions answered and book your Peru flight directly via WhatsApp.",
  },
  {
    name: "Instagram Everywhere",
    handle: "@paraglidingeveryday",
    href: "https://www.instagram.com/paraglidingeveryday/",
    icon: Instagram,
    accent: "from-[#E8622D] to-[#F2A65A]",
    description:
      "Photos and videos of the day's flights.",
  }
];

function FlightPath() {
  const d = "M10 100 C 200 10, 400 110, 600 20 S 780 90, 790 40";
  return (
    <svg
      viewBox="0 0 800 120"
      className="mx-auto mt-8 h-20 w-full max-w-3xl md:h-24"
      aria-hidden="true"
    >
      <path
        d={d}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="2 10"
        strokeLinecap="round"
        className="text-jungle/25"
      />
      <circle r="5" fill="#E8622D">
        <animateMotion dur="7s" repeatCount="indefinite" path={d} />
      </circle>
    </svg>
  );
}

function SocialCard({ profile }) {
  const Icon = profile.icon;
  return (
    <a
      href={profile.href}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative flex flex-col gap-4 rounded-2xl border border-jungle/10 bg-white/70 p-6 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jungle"
    >
      <div
        className={`flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br ${profile.accent} text-white shadow-sm`}
      >
        <Icon className="h-6 w-6" strokeWidth={2} />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-jungle">{profile.name}</h3>
        <p className="text-sm text-jungle/60">{profile.handle}</p>
      </div>
      <p className="text-sm leading-relaxed text-jungle/70">
        {profile.description}
      </p>
      <span className="mt-auto inline-flex items-center gap-1 text-sm font-medium text-jungle transition-all group-hover:gap-2">
        Seguir <ArrowUpRight className="h-4 w-4" />
      </span>
    </a>
  );
}

export default function SocialMediaHub() {
      const { t } = useLang();
  
  return (
    <section className="relative bg-sand px-6 py-20 md:py-28">
      <div className="mx-auto max-w-5xl text-center">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E8622D]">
            {t.social.tagline}
         </span>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-jungle md:text-5xl">
          {t.social.title}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-jungle/70">
          {t.social.description}
        </p>
        <FlightPath />
      </div>

      <div className="mx-auto mt-4 grid max-w-5xl gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SOCIAL_PROFILES.map((profile) => (
          <SocialCard key={profile.name} profile={profile} />
        ))}
      </div>
    </section>
  );
}